import { adalOneApiFetch } from "../adalConfig";
import { TenantStatus } from "../enums/TenantStatus";
import { IAddTenantViewModel } from "../models/viewmodels/tenant/IAddTenantViewModel";
import { SubscriptionResponse } from "../models/responseModels/tenant/SubscriptionResponse";

class TenantService {
  public async doesTenantExist(): Promise<TenantStatus> {
    try {
      const response: Response = await adalOneApiFetch(
        fetch,
        `${process.env.REACT_APP_ONE_API_URL}/api/v1.0/tenant`,
        {},
      );

      if (response.status === 200) {
        return TenantStatus.Exists;
      }

      if (response.status === 404) {
        return TenantStatus.DoesNotExist;
      }

      return TenantStatus.Error;
    } catch (e) {
      console.error("Error while fetching tenant: ", e);
      return TenantStatus.Error;
    }
  }

  public async setupTenant(data: IAddTenantViewModel): Promise<SubscriptionResponse> {
    const response: Response = await adalOneApiFetch(
      fetch,
      `${process.env.REACT_APP_ONE_API_URL}/api/v1.0/tenant/setup`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
    );

    if (response.status !== 200) {
      throw new Error(response.statusText);
    }

    return await response.json();
  }
}

export const tenantService = new TenantService();
